/* SCNY — mobile autoplay guard for muted background/graphic videos */
(() => {
  const SEL = 'video[autoplay], video[data-scny-autoplay]';
  const tracked = new WeakSet();

  const prep = (v) => {
    if (v.dataset.scnyUnmuted === 'true') return;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.removeAttribute('controlslist');
  };

  const kick = (v) => {
    if (!v.paused || v.dataset.scnyUserPaused === 'true') return;
    if (!v.muted && v.dataset.scnyUnmuted === 'true') return;
    prep(v);
    if (v.readyState === 0 && v.networkState !== 2) v.load();
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const e of entries) if (e.isIntersecting) kick(e.target);
      }, { rootMargin: '200px 0px' })
    : null;

  const track = (v) => {
    if (tracked.has(v)) return;
    tracked.add(v);
    prep(v);
    v.addEventListener('volumechange', () => {
      v.dataset.scnyUnmuted = v.muted ? 'false' : 'true';
    });
    v.addEventListener('pause', () => {
      if (v.controls && !document.hidden && !v.ended) v.dataset.scnyUserPaused = 'true';
    });
    v.addEventListener('play', () => { v.dataset.scnyUserPaused = 'false'; });
    ['loadedmetadata', 'canplay'].forEach((t) => v.addEventListener(t, () => kick(v), { once: true }));
    if (io) io.observe(v); else kick(v);
  };

  const scan = (root = document) => root.querySelectorAll(SEL).forEach(track);
  const kickAll = () => document.querySelectorAll(SEL).forEach(kick);

  const start = () => {
    scan();
    kickAll();
    new MutationObserver((muts) => {
      for (const m of muts) for (const n of m.addedNodes) {
        if (!(n instanceof Element)) continue;
        if (n.matches(SEL)) track(n);
        scan(n);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  /* Low Power Mode / Data Saver block autoplay until first gesture */
  const gesture = () => {
    kickAll();
    ['touchstart', 'touchend', 'click', 'scroll', 'keydown'].forEach((t) =>
      window.removeEventListener(t, gesture, { capture: true })
    );
  };
  ['touchstart', 'touchend', 'click', 'scroll', 'keydown'].forEach((t) =>
    window.addEventListener(t, gesture, { capture: true, passive: true })
  );

  document.addEventListener('visibilitychange', () => { if (!document.hidden) kickAll(); });
  window.addEventListener('pageshow', kickAll);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
